import { APP_API_WS } from './EnvVars';
import { useRef, useState } from 'react';

interface WsMessage {
	MeetingState: {
		roomId: string
		state: {
			user: string
			joined: boolean
		}[]
	}
}
export const WebSocketService = () => {
	const ws = useRef<WebSocket | null>(null);
	const [message, setMessage] = useState<WsMessage | undefined>();

	const initializeWS = (roomId: any, userId: string, callback?: (userId: string, roomId: string) => void) => {
			ws.current = new WebSocket(`${APP_API_WS}/meeting/connect/${userId}/${roomId}`);
		
			ws.current.onopen = () => {
				console.log("websocket opened");
				callback && callback(userId, roomId);
			}
			ws.current.onmessage = (event: any) => {
				setMessage(JSON.parse(event.data));
			};

			ws.current.onclose = (event: any) => {
				console.log("websocket closed", event);
			}
	}

	const onUserEnteredChat = (userId: string, roomId: string) => {
			ws?.current?.send(JSON.stringify({ JoinedMeeting: { roomId, user: userId } }));
	}
	const onUserEnteredCall = (userId: string, roomId: string) => {
	
			ws?.current?.send(JSON.stringify({ JoinedMeeting: { roomId, user: userId } }));
		
	}
	const onUserLeftCall = (userId: string, roomId: string) => {
		ws?.current?.send(JSON.stringify({ LeftMeeting: { roomId, user: userId } }));
	}

	const closeWS = (userId: string, roomId: string, callback?: (userId: string, roomId: string) => void) => {
			callback && callback(userId, roomId);
			ws?.current?.close();
	}

	return {
		closeWS,
		initializeWS,
		onUserEnteredCall,
		onUserEnteredChat,
		onUserLeftCall,
		state: {
			message,
		}
	}
}